import Vue from 'vue';

import FormVue from './Form.vue';
import FormGroupVue from './FormGroup.vue';

export default function formComponent(_Vue: typeof Vue) {
  _Vue.component('AppForm', FormVue);
  _Vue.component('AppFormGroup', FormGroupVue);
}
